<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
console.log('Welcome to PinIt Web')
  export default {
    name: 'App',
    created() {
      const accessToken = localStorage.getItem('accessToken')
      if (accessToken) {
        this.$store.dispatch('auth/getCurrentUser')
      }
    }
  }
</script>

